import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { COLORS } from 'consts/colors'
import styled, { css } from 'styled-components'
import {
  boxShadowStyles,
  flexCenterMixin,
  disableSomeContentStyles,
  iconButtonStyles
} from 'styles/mixins'

export const VerticalLine = styled.div`
  width: 1px;
  height: 18px;
  background: ${COLORS.borderColor};
  opacity: 0;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    opacity: 1;
  }
`

export const SoundListItemWrapper = styled.div<{
  $isDisable?: boolean
  $isLoadingState?: boolean
}>`
  position: relative;
  height: 48px;
  min-height: 48px;
  border: 1px solid ${COLORS.borderColor};
  border-radius: 4px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  transition: all 0.2s ease-in-out;
  width: 100%;
  justify-content: space-between;

  ${props =>
    props.$isLoadingState &&
    css`
      border: none;
      padding: 0;
    `}

  &:hover {
    ${boxShadowStyles('shadow2')}
    border: 1px solid ${COLORS.primaryDark};

    ${VerticalLine} {
      opacity: 1;
    }
  }

  ${props => props.$isDisable && disableSomeContentStyles()}
`

export const PlayButton = styled.button<{
  size: string
}>`
  cursor: pointer;
  width: ${({ size }) => (size === 'extraSmall' ? '18px' : '28px')};
  height: ${({ size }) => (size === 'extraSmall' ? '18px' : '28px')};
  background: ${COLORS.white};
  ${flexCenterMixin()}

  &:hover {
    svg {
      path {
        fill: ${COLORS.secondaryDark};
      }
    }
  }
`

export const SoundListItemSidesWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const IconButtonWrapper = styled.div<{ $disabled?: boolean }>`
  ${({ $disabled }) => iconButtonStyles($disabled)}
`
